/**
 * LA DEMANDE QUI VIENT D'ÊTRE CRÉÉE.
 *
 * You fill the form, you press Create, the modal closes — and the request you
 * just made is one row among four hundred, indistinguishable from the rest.
 * "Did it save?" is answered by scrolling and reading.
 *
 * So creating one names it here, and whichever list is on screen scrolls to
 * that row and flashes it once. A one-shot: read on arrival and cleared, so a
 * later visit does not flash yesterday's work.
 */
const listeners = new Set<() => void>();
let fresh: string | null = null;

export function markNewActe(id: string | null): void {
  fresh = id;
  listeners.forEach((l) => l());
}

/** Read it and keep it — the row flashes for as long as the CSS says. */
export function newActe(): string | null {
  return fresh;
}

/** Consumed once the flash has played. */
export function clearNewActe(): void {
  if (!fresh) return;
  fresh = null;
  listeners.forEach((l) => l());
}

export function onNewActe(cb: () => void): () => void {
  listeners.add(cb);
  return () => { listeners.delete(cb); };
}
